import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "OOSRATE",
  title: defineMessage({
    id: "fig.access.OOSRATE.title",
    defaultMessage: "Out-of-school rate by level",
  }),
  caption: defineMessage({
    id: "fig.access.OOSRATE.caption",
    defaultMessage: "The out-of-school rates have stagnated for many years",
  }),
  source: defineMessage({
    id: "fig.access.OOSRATE.source",
    defaultMessage: "UIS database",
  }),
};
